export default "__VITE_ASSET__CjSbBpTi__"